import React, { Component } from 'react';
import autobind from 'react-autobind'

export default class SubscriptionBox extends Component {

    constructor(props) {
        super(props)
        autobind(this)
    }

    render() {

        const { subscription, register } = this.props,
            {
                // duration, 
                name, price, style, storageText, trafficText, duration } = subscription;
        const styleMapper = {
            BEST_CHOICE: 'pricing-table-orange',
            DEMO: 'pricing-table-free',
            BASIC: 'pricing-table-basic'
        }

        return (
            <div className={'pricing-table ' + styleMapper[style] + (this.props.isBestChoice ? ' pricing-table-best-choice' : '')}>

                {(this.props.isBestChoice ? <div className="pricing-table-best-choice-text text-uppercase">Best choice</div> : null)}
                <div className="pricing-table-title text-uppercase">{name}</div>
                <div className="pricing-table-price text-uppercase"><span className="value">{price === 0 ? 'free' : (<span>{price}€<span className="price-asterisk">*</span></span>)}</span></div>
                <div className="pricing-table-frecuency">{duration} months</div>
                <div className="panel-divider panel-divider-xl"></div>
                <ul className="pricing-table-features">
                    <li><b>{storageText}</b></li>
                    {trafficText ? (<li><b>{trafficText}</b></li>) : (<li></li>)}
                </ul>
                {!register && this.props.activePlan ? <div className="active-plan">Active Plan</div> : <button className="btn btn-rounded btn-sm-lateral-space btn-space btn-secondary mt-2 mb-3" onClick={this.props.onChoosePlanClick}>Confirm Plan</button>}

                {this.props.active ? (<div className="actions d-flex"><span className="s7-check" onClick={this.props.onConfirmUpgrade}></span>{!register ? (<span className="s7-close" onClick={this.props.removeSelection}></span>) : null}</div>) : ''}

            </div>
        );

    }

}



// WEBPACK FOOTER //
// ./src/components/Subscription/SubscriptionBox.js